import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Rocket, Shield, Users, Lightbulb, Target, Heart } from 'lucide-react';

export function CultureSection() {
  const values = [
    {
      icon: Lightbulb,
      title: 'Innovation',
      description: 'We constantly push boundaries and explore new possibilities in technology.',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/30'
    },
    {
      icon: Shield,
      title: 'Divine',
      description: 'Showing how we should have don anything regarding our world.',
      color: 'text-accent',
      bgColor: 'bg-accent/20',
      borderColor: 'border-accent/30'
    },
    {
      icon: Users,
      title: 'Radiance',
      description: 'A methapore warmth , kindess , or the light of compassion.',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/30'
    },
    {
      icon: Rocket,
      title: 'Excellence',
      description: 'We strive for perfection in every project, setting new industry standards.',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/30'
    },
    {
      icon: Target,
      title: 'Precision',
      description: 'Attention to detail and accuracy in execution defines our work ethic.',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/30'
    },
    {
      icon: Heart,
      title: 'Integrity',
      description: 'Representing something being whole and Undivided',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/30'
    }
  ];

  return (
    <section id="culture" className="py-20 relative bg-muted/5">
      <div className="absolute inset-0 digital-grid opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-accent/20 text-accent border-accent/30 font-orbitron">
            Culture & Values
          </Badge>
          <h2 className="text-4xl md:text-5xl font-orbitron font-bold text-primary mb-6">
            What Drives Us Forward
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-accent to-secondary mx-auto mb-8"></div>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our values aren't just words on a wall - they're the fundamental principles that guide 
            every decision, every innovation, and every relationship we build.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <Card 
                key={index} 
                className={`p-8 bg-card/30 backdrop-blur ${value.borderColor} hover:${value.borderColor.replace('/30', '/60')} transition-all duration-300 hover:tech-glow hover:-translate-y-2`}
              >
                <div className={`w-16 h-16 ${value.bgColor} rounded-2xl flex items-center justify-center mb-6`}>
                  <Icon className={`w-8 h-8 ${value.color}`} />
                </div>
                
                <h3 className={`text-xl font-orbitron font-semibold ${value.color} mb-4`}>
                  {value.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed">
                  {value.description}
                </p>
                
                <div className={`mt-6 w-full h-1 ${value.bgColor} rounded-full`}>
                  <div className={`h-full bg-gradient-to-r from-${value.color.split('-')[1]} to-transparent rounded-full animate-pulse`} style={{ width: '75%' }}></div>
                </div>
              </Card>
            );
          })}
        </div>
        
        {/* Culture Statement */}
        <Card className="mt-16 p-12 bg-gradient-to-r from-card/20 to-primary/5 border-primary/20 text-center">
          <h3 className="text-3xl font-orbitron font-bold text-primary mb-6">
            Our Culture Promise
          </h3>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto">
            At TechCorp, we foster an environment where creativity flourishes, collaboration thrives, 
            and every team member is empowered to make a meaningful impact. We believe that when 
            passionate people come together with shared values, extraordinary things happen.
          </p>
        </Card>
      </div>
    </section>
  );
}